import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import ProductCard from "@/components/feature/ProductCard";
import { productsByCategory } from "@/mocks/products";
import { categories } from "@/data/categories";

export default function ProductsPage() {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <main className="mx-auto max-w-7xl px-4 py-8 md:px-6">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-foreground-900 md:text-3xl">
            All Products
          </h1>
          <p className="mx-auto mt-3 max-w-xl text-sm text-foreground-600 md:text-base">
            Browse products from the AllChinaBuy spreadsheet. Click any product to view and purchase on the main website.
          </p>
        </div>

        {categories.map((cat) => {
          const catProducts = productsByCategory[cat.id] || [];
          if (catProducts.length === 0) return null;
          return (
            <section key={cat.id} id={cat.id} className="mt-14">
              <div className="flex items-center justify-between">
                <h2 className="text-xl font-bold text-foreground-900 md:text-2xl">
                  {t(cat.nameKey)}
                </h2>
              </div>
              <div className="mt-5 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
                {catProducts.map((product) => (
                  <ProductCard key={product.id} product={product} />
                ))}
              </div>
            </section>
          );
        })}

        <div className="mt-14 flex justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <span className="mr-2 flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-left-line"></i>
            </span>
            Back to Home
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
}